import React from 'react';
const bonuses = [{
  title: 'ADVANCED RUNNING WORKOUT LIBRARY™',
  description: 'Una raccolta professionale di allenamenti avanzati pronti all\'uso, organizzati per obiettivo fisiologico, distanza e livello dell\'atleta. Include sessioni complete con volumi, intensità, recuperi, progressioni e varianti già definite per ridurre drasticamente il tempo dedicato alla preparazione.'
}, {
  title: 'RACE STRATEGY & COMPETITION PLANNER™',
  description: 'Un sistema completo dedicato alla preparazione delle gare con strategie per 5K, 10K, Mezza Maratona, Maratona e Trail Running. Include checklist, protocolli pre-gara, strategie di ritmo, gestione dell\'idratazione, analisi post-gara e strumenti professionali già pronti.'
}, {
  title: 'STRENGTH & INJURY PREVENTION VAULT™',
  description: 'Una raccolta completa di programmi professionali di forza e prevenzione degli infortuni specifici per runner. Comprende routine complete, progressioni, circuiti e protocolli pronti per integrare il lavoro complementare all\'interno di qualsiasi pianificazione.'
}, {
  title: 'PROFESSIONAL ASSESSMENT & TESTING PACK™',
  description: 'Un sistema professionale di test e valutazione con batterie complete, schede di monitoraggio, report, registri e modelli pronti per controllare l\'evoluzione delle prestazioni degli atleti durante tutta la stagione.'
}, {
  title: 'RUNNING COACH PROFESSIONAL FORMS™',
  description: 'Una raccolta completa di modelli professionali pronti all\'uso: schede atleta, anamnesi sportiva, diari di allenamento, registri dei carichi, calendari, report, checklist e documentazione organizzativa per lavorare con maggiore efficienza e professionalità.'
}];
const changes = [{
  emoji: '⚡',
  title: 'Risparmia Ore Ogni Settimana',
  lines: ['Smetti di creare programmi, sessioni, valutazioni e documentazione da zero.', 'Apri il sistema. Scegli il materiale. Personalizzalo se necessario. E prepara settimane di allenamento in pochi minuti.']
}, {
  emoji: '👑',
  title: 'Lavora con Maggiore Professionalità',
  lines: ['Organizza il tuo lavoro con un sistema completo composto da programmi, sessioni, valutazioni, pianificazioni e strumenti professionali già pronti.', 'Offri ai tuoi atleti un metodo più organizzato, efficace e professionale.']
}, {
  emoji: '🏃',
  title: 'Aiuta i Tuoi Atleti a Ottenere Prestazioni Migliori',
  lines: ['Utilizza programmi strutturati, sistemi di progressione e strumenti di monitoraggio che ti permettono di seguire ogni runner con maggiore precisione, continuità ed efficacia durante tutta la stagione.']
}, {
  emoji: '😊',
  title: 'Concentrati Finalmente Sul Coaching',
  lines: ['Dedica meno tempo alla preparazione dei programmi e più tempo ad allenare, osservare, motivare e migliorare le prestazioni dei tuoi atleti.', 'È questo il vero lavoro di un Running Coach.']
}];
export function BonusSection() {
  return <>
      <section className="py-6 px-4 sm:px-6 bg-navy text-white" data-id="element-15" data-mp="59uw9mdujnhb">
        <h2 className="text-lg sm:text-3xl font-heading font-extrabold text-center text-gold leading-tight uppercase mb-4" data-id="element-16" data-mp="5c7l8ji0uy3v">
          🎁 In Più Riceverai 5 Bonus Esclusivi
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-4xl mx-auto" data-id="element-17" data-mp="3rq7jn50wpyyy">
          {bonuses.map((bonus, i) => <div key={bonus.title} className={`bg-navy-dark border border-gold/40 p-3.5 rounded-lg ${i === 4 ? 'sm:col-span-2' : ''}`} data-id="element-18" data-mp="j81n4ikdon7h" data-mpi={i}>
              <p className="inline-block bg-gold/20 text-gold font-heading font-bold text-[10px] px-2 py-0.5 rounded mb-1.5 tracking-widest uppercase" data-id="element-19" data-mp="9bgg5rost210">
                🎁 BONUS {i + 1}
              </p>
              <h3 className="text-[13px] sm:text-base font-heading font-bold text-white mb-1 leading-tight" data-id="element-20" data-mp="2u0mcals11vem">
                {bonus.title}
              </h3>
              <p className="text-[12.5px] sm:text-sm text-cream/85 leading-relaxed" data-id="element-21" data-mp="3f8ewf6kodayy">
                {bonus.description}
              </p>
            </div>)}
        </div>
      </section>

      <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-22" data-mp="35hk8lxrs63be">
        <h2 className="text-lg sm:text-3xl font-heading font-extrabold text-center text-navy leading-tight uppercase mb-4" data-id="element-23" data-mp="35g0otx6x1a4v">
          Cosa Cambierà da Oggi
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-4xl mx-auto" data-id="element-24" data-mp="214qhuxlgspb">
          {changes.map(item => <div key={item.title} className="bg-white border-l-4 border-navy p-3.5 rounded-r-lg shadow-sm" data-id="element-25" data-mp="3t5uyy6zuoklf">
              <h3 className="text-[13px] sm:text-base font-heading font-bold text-navy mb-1 leading-snug" data-id="element-26" data-mp="3jajnpynnhvif">
                <span aria-hidden="true" data-id="element-27" data-mp="2cuqzar0brvps">{item.emoji}</span> {item.title}
              </h3>
              {item.lines.map((line, j) => <p key={j} className="text-anthracite text-[12.5px] sm:text-sm leading-relaxed mb-1 last:mb-0" data-id="element-28" data-mp="27wpkii9xmik4" data-mpi={j}>
                  {line}
                </p>)}
            </div>)}
        </div>
      </section>
    </>;
}